import '/app/brewery-packages/content/content-editor-plugin-link/src/Link.css-raw';
export default {
  "link": "cover-letter-traditional-173018a8-link-d8xOKa"
};